/**
 * created by li si yi
 *
 */
import React, {Component} from 'react';
import {Button, message, Modal, Tooltip, Popconfirm} from "antd";
import MyTable from "./component/MyTable";
import moment from "moment";
import {Scrollbars} from "react-custom-scrollbars";
import './component/MyTable.css'
import BaseComponent from "../../base/BaseComponent";
import BaseTable from "../components/baseTable/BaseTable";
import MediaList from "./component/modal/mediaList";
import {getColorByState} from "../components/colorByState/colorByState";
import deptIcon from "./component/img/dept.png";
import use from "./component/img/use.png";
import discard from "./component/img/discard.png";
import {HEADER_HEIGHT} from "../../constants";

export default class NewsContribute extends BaseComponent {
    constructor(props) {
        super(props);

        this.abstractDataEditorHandlerName = this.sysConfigGetValueByKey("abstract.data.editor.handler.name","receiveStoryDataHandler,webNewsDataHandler").split(",");
        this.abstractDataEditorHandler = (()=>{
            return this.abstractDataEditorHandlerName.map(name=>{
                return require(`../components/abstractDataHandler/${name}`).default;
            });
        })();

        this.state = {
            //权限分配
            // authority: '审核员',
            other: ['博达新闻网', '博达新闻网'],
            mediaListModalVisible : false,
            mediaListData: [],
            publishMediaListModalVisible: false,
            publishMediaListData: [],
            deptListModalVisible: false,
            contributeDept : [],
            submitVisible:false,
            targetInfo:[],
            //表格数据
            columns: [
                {
                    title: '标题',
                    dataIndex: 'title',
                    key: 'title',
                    render: (text, record) => {
                        let title=text;
                        if(!title && record.variableFields && record.variableFields['title']) {
                            title=record.variableFields['title'];
                        }
                        return (
                            <div className={'titleContent'}>
                                {/*点击跳转*/}
                                <div style={{
                                    // flex:1,
                                    maxWidth:'calc( 100% - 32px )',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    marginRight:8,
                                }} onClick={()=>{
                                    if(record.id){
                                        let activitiConfName = this.sysConfigGetValueByKey("editor.activiti.conf.name.tglc", "activitiTreeRoot-xlc-tglc");
                                        switch (record.activitiCategoryKey) {
                                            case "likewebsite":
                                                window.openEditById({configName:"materialCenterStoryEditor",id:record.id,params: {activitiConfName:"activitiTreeRoot-xlc-sczxsglc"}});
                                                break;
                                            case "tggj":
                                                window.openEditById({configName:"storyEditor",id:record.id,params: {activitiConfName:activitiConfName}});
                                                break;
                                            default:
                                                window.openEditById({configName:"storyEditor",id:record.id,params: {activitiConfName:activitiConfName}});
                                                break;
                                        }
                                        return false;
                                        if(record.sonsLength === 1){//如果有子稿件
                                            this.getReceiveStory(record.id, (data)=>{
                                                if(!data || data.length<1){
                                                    message.error("子稿件列表不存在，但是返回的数据sonsLength却为1！");
                                                    return;
                                                }
                                                if(data.length !== 1){
                                                    message.warn("子稿件列表长度不为1,将默认取第一个");
                                                }
                                                let first = data[0];
                                                let storyId = first.id;
                                                this.openSon(storyId,record.id, first);
                                            });
                                        }else if(record.sonsLength > 1){//如果有子稿件
                                            //如果有多篇子稿件
                                            this.showReceiveStory(record.id);
                                        }else{
                                            let activitiConfName = this.sysConfigGetValueByKey("editor.activiti.conf.name.tglc", "activitiTreeRoot-xlc-tglc");
                                            if(record.statusName === "草稿"){
                                                window.openEditById({params:{activitiConfName},configName:record.openEditorStyle?record.openEditorStyle:"storyEditor",id:record.id});
                                                return;
                                            }
                                            window.openEditById({params:{activitiConfName},configName:record.openEditorStyle?record.openEditorStyle:"storyEditor",id:record.id})
                                        }
                                    } else {
                                        message.error("稿件id丢失！")
                                    }
                                }}><Tooltip title={title} placement={"topLeft"}>{title}</Tooltip></div>
                            </div>
                        )
                    },
                },
                {
                    title: '投稿至',
                    dataIndex: 'submitTarget',
                    key: 'submitTarget',
                    // ellipsis:true,
                    width:280,
                    render: (text, record) => {
                        let targetInfo = record && record.targetInfo && record.targetInfo.length ? record.targetInfo : [];
                        let mediaName = targetInfo && targetInfo[0] && targetInfo[0].deptName;
                        if(!mediaName){
                            mediaName = record.deptName
                        }
                        let targetInfoLength = targetInfo&&targetInfo.length;
                        return (
                            <div style={{
                                display:'flex',
                                cursor:targetInfoLength?"pointer" : ""}}
                                onClick={() => {
                                    if (!(targetInfoLength)) {
                                        return false
                                    }
                                    this.setState({submitVisible: true, targetInfo: targetInfo})
                                }}
                            >
                                <div style={{
                                    maxWidth: targetInfo.length > 1 ? 160 : 175,
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                }}>
                                    {mediaName}
                                </div>

                             {
                                  targetInfo.length===1&&targetInfo[0].status?<span style={{color:targetInfo[0].status=="已采用"? "#95F204" : "#F59A23"}}>（{targetInfo[0].status}）</span>:null
                              }
                              {
                                  targetInfo.length >1 ? <span>等&nbsp;<span style={{color:"#D9001B"}}>{targetInfo.length}</span>&nbsp;个单位</span> : ""
                              }

                          </div>
                        )
                        // let mediaName = text&&text.length?text[0]:'';
                        // let media=(<div style={{display:'flex'}}>
                        //     <span className={"text-pointer"} style={{maxWidth:100}}><Tooltip placement={"topLeft"} title={!text?"":text.join("，")}>{mediaName}</Tooltip></span>
                        //     {
                        //         text&&text.length>1?<div style={{padding:"0 5px"}}>等<span
                        //             onClick={()=>{
                        //                 if(record.targetIds && record.targetIds.length > 1){
                        //                     this.getContributeTargetList(record.targetIds.join(","), (data)=>{
                        //                         let convertData = ()=>{
                        //                             let result = [];
                        //                             for(let i = 0; data && i < data.length; i++){
                        //                                 let item = data[i];
                        //                                 result[i] = {icon: item.logoUrl, type:item.mediaTypeName, data: item.mediaList?item.mediaList.map(media=>{return {name:media.name}}):[]};
                        //                             }
                        //                             return result;
                        //                         };
                        //                         let mediaListData = convertData();
                        //                         if(record.targetType === "media"){
                        //                             this.setState({mediaListModalVisible:true, mediaListData});
                        //                         }else{
                        //                             this.setState({deptListModalVisible:true});
                        //                         }
                        //                     });
                        //                 }
                        //             }}
                        //             style={{color:"red",padding:"0 5px",cursor:"pointer"}}>{text.length}</span>个媒体</div>:null
                        //     }
                        // </div>);
                        // let oIcon = record.mediaLogo?<img src={record.mediaLogo} className={'oIcon'}/>:null;
                        // let content = mediaName ? (
                        //     <>
                        //         {oIcon}
                        //         {media}
                        //     </>
                        // ) : (<div style={{marginLeft: '15px'}}>-</div>);
                        // return (
                        //     <div className={'media'}>
                        //         {content}
                        //     </div>
                        // )
                    }
                },
                {
                    title: '创建人',
                    dataIndex: 'submitterName',
                    key: 'submitterName',
                    width:150,
                    render: (text, record) => {
                        return (
                            <div
                                title={text}
                                style={{
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                }}
                            >
                                {text}
                            </div>
                        )
                    }
                },
                {
                    title: '修改时间',
                    dataIndex: 'createTime',
                    key: 'createTime',
                    width:170,
                    render: (text , record) => {
                        let createTime = record.createTime ? moment(record.createTime).format('YYYY-MM-DD HH:mm:ss') : null;
                        let updateTime = record.updateTime ? moment(record.updateTime).format('YYYY-MM-DD HH:mm:ss') : null;
                        return (
                            <div style={{cursor:"default"}}>
                                <Tooltip placement={"top"} title={<div>
                                    <div>创建时间: {createTime}</div>
                                    <div>修改时间: {updateTime}</div>
                                </div>}>{updateTime}</Tooltip>
                            </div>)
                    }
                },
                {
                    title: '状态',
                    dataIndex: 'statusName',
                    key: 'statusName',
                    ellipsis:true,
                    width: 140,
                    render: (text) => {
                        let color = getColorByState(text);
                        return (
                            <div className={'dotState'}>
                                <div style={{background: color}}></div>
                                <span className={"text-pointer"} style={{width:100}}><Tooltip title={text}>{text}</Tooltip></span>
                            </div>
                        )
                    }
                },
                {
                    title: '操作',
                    dataIndex: 'state',
                    key: 'states',
                    width:150,
                    render: (text, record) => {
                        let button = null;
                        switch (record.statusName) {
                            case '草稿':
                                button = <Popconfirm title="确定要删除吗？" okText="确定" cancelText="取消" onConfirm={()=>{this.deleteStory(record.id)}}><Button type={'link'} size={"small"}>删除</Button></Popconfirm>
                                break;
                            case '已发布':
                            case '发布':
                                button = <Button type={'link'} size={"small"} onClick={()=>{
                                    this.getPublishList(record.id, (data)=>{
                                        let convertData = ()=>{
                                            let group = [];
                                            let names = [];
                                            for(let i = 0; data && i < data.length; i++){
                                                let item = data[i];
                                                if(item.mediaType){
                                                    let index = names.indexOf(item.mediaType);
                                                    if(index === -1){//不存在
                                                        if(!item.contentName){
                                                            group.push({icon: item.mediaLogoUrl, type:item.mediaType, data: [{href: item.linkUrl, name:item.mediaName}]});
                                                        }else{
                                                            group.push({icon: item.mediaLogoUrl, type:item.mediaType, data: [{href: item.linkUrl, name:item.mediaName + "/" + item.contentName}]});
                                                        }
                                                        names.push(item.mediaType);
                                                    }else{
                                                        if(!item.contentName){
                                                            group[index].data.push({href: item.linkUrl, name: item.mediaName});
                                                        }else{
                                                            group[index].data.push({href: item.linkUrl, name: item.mediaName + "/" + item.contentName});
                                                        }
                                                    }
                                                }
                                            }
                                            console.log("group:  ", group);
                                            console.log("names:  ", names);
                                            return group;
                                        };
                                        let publishMediaListData = convertData();
                                        console.log("getPublishList    data:    ", data);
                                        this.setState({publishMediaListModalVisible:true, publishMediaListData})
                                    });
                                }}>查看发布</Button>
                                break;
                            default:
                                button = <div style={{marginLeft: '15px'}}>-</div>
                        }
                        if(record&&record.variableFields&&record.variableFields.publish==1){
                            button = <Button type={'link'} size={"small"} onClick={()=>{
                                this.getPublishList(record.id, (data)=>{
                                    let convertData = ()=>{
                                        let group = [];
                                        let names = [];
                                        for(let i = 0; data && i < data.length; i++){
                                            let item = data[i];
                                            if(item.mediaType){
                                                let index = names.indexOf(item.mediaType);
                                                if(index === -1){//不存在
                                                    if(!item.contentName){
                                                        group.push({icon: item.mediaLogoUrl, type:item.mediaType, data: [{href: item.linkUrl, name:item.mediaName}]});
                                                    }else{
                                                        group.push({icon: item.mediaLogoUrl, type:item.mediaType, data: [{href: item.linkUrl, name:item.mediaName + "/" + item.contentName}]});
                                                    }
                                                    names.push(item.mediaType);
                                                }else{
                                                    if(!item.contentName){
                                                        group[index].data.push({href: item.linkUrl, name: item.mediaName});
                                                    }else{
                                                        group[index].data.push({href: item.linkUrl, name: item.mediaName + "/" + item.contentName});
                                                    }
                                                }
                                            }
                                        }
                                        console.log("group:  ", group);
                                        console.log("names:  ", names);
                                        return group;
                                    };
                                    let publishMediaListData = convertData();
                                    console.log("getPublishList    data:    ", data);
                                    this.setState({publishMediaListModalVisible:true, publishMediaListData})
                                });
                            }}>查看发布</Button>
                        }
                        return (
                            <div>
                                {button}
                            </div>
                        )
                    },
                }
            ],
            thisTabKey: '我提交的稿件',
            // 选项卡数据
            tabBar: {
                tabList: [
                    {
                        key: '本部门稿件',
                        permission: 'show_current_dept_tab',
                        url: '/cm-sites-pms/story/contribute/currDept',
                    },
                    {
                        key: '我提交的稿件',
                        permission: '',
                        url: '/cm-sites-pms/story/contribute/mySubmit',
                    },
                    {
                        key: '草稿',
                        permission: '',
                        url: '/cm-sites-pms/story/contribute/draft',
                    },
                    {
                        key: '待我处理',
                        permission: '',
                        url: '/cm-sites-sys/process/getTodoList',
                        params: {
                            showData:true,
                            operatorUser: this.getInfo().currentUser.id,
                            // activitiCategoryKeys: ['storyToWebNews', 'tggj'],
                            activitiCategoryKeys: ['likewebsite', 'tggj'],
                            title: '',
                            page:{
                                start: 1,
                                size: 10,
                            }
                        },
                    },
                    {
                        key: '已发布',
                        permission: '',
                        url: '/cm-sites-pms/story/contribute/publish',
                    },
                    // {
                    //     key: '已弃用',
                    //     permission: '',
                    //     url: '/cm-sites-pms/story/contribute/abandon',
                    // },
                    // {
                    //     key: '已撤稿',
                    //     permission: '',
                    //     url: '/cm-sites-pms/story/contribute/withdraw',
                    // },
                ],
                params: {
                    keywords: '',
                    page: 1,
                    size: 10,
                },
                data: {
                    // 当前所选的tab
                    dataSource: [],
                    total: 10,
                },
            },
            // 子稿件弹框是否显示
            showReceiveStoryVisible: false,
            // 子项稿件列表表头
            childrenColumn: [
                {
                    title: '标题',
                    dataIndex: 'title',
                    key: 'title',
                    ellipsis: true,
                    render: (title, record)=>{
                        let recodeId = this.state.recodeId;
                        return <Tooltip title={title} placement={"topLeft"}>
                            <div onClick={()=>{this.openSon(record.id,recodeId,record);}} className={"text-pointer"} style={{cursor:"pointer"}}>{title}</div>
                        </Tooltip>
                    }
                },
                {
                    title: '投稿至',
                    dataIndex: 'contributeMedia',
                    key: 'contributeMedia',
                    width:280,
                    render: (text, record) => {
                        let mediaName = text&&text.length?text[0]:'';
                        let media=(<div style={{display:'flex'}}>
                            <span className={"text-pointer"} style={{maxWidth:100}}><Tooltip placement={"topLeft"} title={!text?"":text.join("，")}>{mediaName}</Tooltip></span>
                            {
                                text&&text.length>1?<div style={{padding:"0 5px"}}>等<span
                                    onClick={()=>{
                                        if(record.mediaIds && record.mediaIds.length > 1){
                                            this.getContributeTargetList(record.mediaIds.join(","), (data)=>{
                                                let convertData = ()=>{
                                                    let result = [];
                                                    for(let i = 0; data && i < data.length; i++){
                                                        let item = data[i];
                                                        result[i] = {icon: item.logoUrl, type:item.mediaTypeName, data: item.mediaList?item.mediaList.map(media=>{return {name:media.name}}):[]};
                                                    }
                                                    return result;
                                                };
                                                let mediaListData = convertData();
                                                this.setState({mediaListModalVisible:true, mediaListData});
                                            });
                                        }
                                    }}
                                    style={{color:"red",padding:"0 5px",cursor:"pointer"}}>{text.length}</span>个媒体</div>:null
                            }
                        </div>);
                        let oIcon = record.mediaLogo?<img src={record.mediaLogo} className={'oIcon'}/>:null;
                        let content = mediaName ? (
                            <>
                                {oIcon}
                                {media}
                            </>
                        ) : (<div style={{marginLeft: '15px'}}>-</div>);
                        return (
                            <div className={'media'}>
                                {content}
                            </div>
                        )
                    }
                },
                {
                    title: '创建人',
                    dataIndex: 'submitterName',
                    key: 'submitterName',
                    width:150,
                },
                {
                    title: '创建日期',
                    dataIndex: 'createTime',
                    key: 'createTime',
                    width:220,
                    render: (text) => {
                        let createTime = text?moment(text).format('YYYY-MM-DD HH:mm'):null;
                        return (
                            <div>
                                {createTime}
                            </div>
                        )
                    }
                },
                {
                    title: '状态',
                    dataIndex: 'statusName',
                    key: 'statusName',
                    width:200,
                    render: (text) => {
                        let color = getColorByState(text);
                        return (
                            <div className={'dotState'}>
                                <div style={{background: color}}></div>
                                {text}
                            </div>
                        )
                    }
                },
            ],
            // 子稿件列表数据
            childrenDataSource: [],
            recodeId:null,//当前选中稿件id
        };
    }


    componentWillMount() {
        this.getDataSource();
        // 获取tabbars  通过接口
        let newTabList = [];
        // 组装tabbars
        this.state.tabBar.tabList.forEach(item=>{
           if(!item.permission || this.permissionCheck(item.permission)) {
               newTabList.push(item);
           }
        });
        this.state.tabBar.tabList = newTabList;
        let that = this;
        this.createPostMessage((e)=>{
            that.getDataSource();
        }, "NewsContribute")
    }

    componentDidMount() {
    }

    componentWillUnmount() {
        this.destroyPostMessage("NewsContribute")
    }



    /**
     * 根据storyId去查询 1.1.X 版本的数据，根据不同的数据打开不同的编辑器
     * @param storyId
     */
    openSon(storyId,recodeId,record) {
        // 微信稿件不要查询1.1.1
        if(record && record.mainMedia && record.mainMedia.mediaTypeCode && record.mainMedia.mediaTypeCode=="material") {
            this.openEditor(storyId,recodeId,record);
            return
        }
        this.request({
            url: "/cm-sites-pms/story/getMediaNewsByStory",
            body: {
                storyId
            },
            callBack: (abstractData) => {
                if(abstractData) {
                    this.openEditor(storyId,recodeId,abstractData)
                } else {
                    message.warn("媒体编辑已将稿件删除")
                }
            }
        })
    }

    openEditor = (storyId,recodeId,abstractData) => {
        this.abstractDataEditorHandler.map(Class => {
            let handler = new Class();
            if (handler["isSupport"](abstractData)) {
                handler["handle"](({params, configName, id}) => {
                    let newParams = {
                        ...params,
                        storyId: recodeId
                    };
                    window.openEditById({params:newParams, configName, id});
                    return;
                });
            }
        });
    };

    getPublishList = (storyId, callBack)=>{
        this.request({
            url : "/cm-sites-pms/story/viewRelease",
            body: {storyId}, callBack
        })
    };

    getContributeTargetList = (ids, callBack)=>{
        this.request({
            url : "/cm-sites-pms/media/getMediaGroupByIds",
            body: {ids}, callBack
        })
    };

    getContributeIds = (data)=>{
        let ids = [];
        data && data.map(item => {
            if(item.activitiCategoryKey === "tggj"){
                if(item.data && item.data.targetIds && (item.data.targetIds instanceof Array) && (item.data.targetIds.length > 0)){
                    ids.push(item.data.id);
                }
            }
        });
        return ids;
    };

    /**
     * 待我处理中流程数据转换，投稿至的那个功能展示，  这里是转换投稿返回的稿件
     * @param ids
     * @param callBack
     */
    activitiDataConvertContributeInfo = (ids, callBack)=>{
        this.request({
            url:"/cm-sites-pms/story/contribute/getContributeInfo",
            body:{ids},callBack
        });
    };

    getMediaNewIds = (data)=>{
        let ids = [];
        data && data.map(item => {
            if(item.activitiCategoryKey !== "tggj"){
                ids.push(item.data.id);
            }
        });
        return ids;
    };

    /**
     * 待我处理中流程数据转换，投稿至的那个功能展示,这里是转换网站返回的稿件
     * @param ids
     * @param callBack
     */
    activitiDataConvertReceiveInfoByMediaNews = (ids, callBack)=>{
        this.request({
            url:"/cm-sites-pms/story/contribute/getReceiveInfoByMediaNews",
            body:{ids},callBack
        });
    };

    getReceiveIds = (data)=>{
        let ids = [];
        data && data.map(item => {
            if(item.activitiCategoryKey === "likewebsite"){
                if(item.data && item.data.mediaIds && (item.data.mediaIds instanceof Array) && (item.data.mediaIds.length > 0)){
                    ids.push(item.data.id);
                }
            }
        });
        return ids;
    };

    getReceiveDeptIds = (data) => {
        let ids = [];
        data && data.map(item => {
            if(item.activitiCategoryKey === "likewebsite"){
                if(item.data && item.data.mediaIds && (item.data.mediaIds instanceof Array) && (item.data.mediaIds.length > 0)){
                    ids.push(item.data.deptId);
                }
            }
        });
        return ids;
    };

    /**
     * 待我处理中流程数据转换，投稿至的那个功能展示,这里是转换收稿返回的稿件
     * @param ids
     * @param callBack
     */
    activitiDataConvertReceiveInfo = (ids, callBack)=>{
        this.request({
            url:"/cm-sites-pms/story/material/getReceiveInfo",
            body:{ids},callBack
        });
    };

    getDeptByIds = (ids, callBack) => {
        this.request({
            url:"/cm-sites-sys/dept/getByIds",
            method:'post',
            contentType:"json",
            body:ids,callBack
            // callBack:(data)=>{
            //     if(!(data&&data.length)){
            //         callBack(false)
            //     }
            //     tabBar.data['dataSource'].forEach((item,index)=>{
            //         data.forEach((Item,Index)=>{
            //             if(item.deptId==Item.id){
            //                 tabBar.data['dataSource'][index].deptName=Item.name
            //             }
            //         })
            //     });
            //     that.setState({})
            // }
        })
    };

    getDataSource=()=>{
        let {thisTabKey,tabBar}=this.state;
        if(thisTabKey === '待我处理') {
            return this.getActivityDataSource()
        }
        let {tabList} = this.state.tabBar;
        // 获取当前tab参数
        let thistab = tabList.find(item => item.key === thisTabKey);
        let params = tabBar.params;
        let that = this;
        let url = thistab.url;
        this.request({
            url,
            body: params,
            callBack: function (res) {
                let dataSource = [];
                let total = 0;
                if (res) {
                    total = res.count;
                    dataSource = res.data;
                }
                tabBar.data['total'] = total;
                tabBar.data['dataSource'] = dataSource;
                that.setState({})
            },
            errorCallBack: function (e) {
            }

        });
    };

    getActivityDataSource=()=>{
        let {thisTabKey,tabBar}=this.state;
        let {tabList} = this.state.tabBar;
        // 获取当前tab参数
        let thistab = tabList.find(item => item.key === thisTabKey);
        let oldParams = tabBar.params;
        let params = thistab.params;
        params.title = oldParams.keywords;
        params.page.start = oldParams.page;
        params.page.size = oldParams.size;
        let that = this;
        let url = thistab.url;
        this.request({
            url,
            method:'post',
            body: params,
            contentType:'json',
            callBack: function (res) {
                let dataSource = [];
                let total = 0;
                if (res && res.data && res.data.length) {
                    total = res.count;
                    dataSource = res.data;
                }
                tabBar.data['total'] = total;
                tabBar.data['dataSource'] = dataSource && dataSource.map(item=>({
                    ...item.data,
                    activitiCategoryKey: item.activitiCategoryKey
                }));
                that.setState({});
                // return false;
                let convertContributeStory = (storys, call)=>{
                    for(let i = 0; tabBar.data['dataSource'] && i < tabBar.data['dataSource'].length; i++){
                        let item = tabBar.data['dataSource'][i];
                        for(let j = 0 ; j < storys.length; j++){
                            let story = storys[j];
                            call(item, story);
                        }
                    }
                    that.setState({});
                };
                //取所有datasource中是否有没有当前部门列表的参数，filter
                // let dataSourceOldArr =  tabBar.data['dataSource'].filter(item=>!item.targetInfo);
                //过滤出的东西取当前部门id
                // let ids = dataSourceOldArr.map(item=> item.deptId);
                //通过id调获取部门的接口
                let ids = that.getReceiveDeptIds(dataSource);
                ids.length>0 && that.getDeptByIds(ids, (data)=>{
                    convertContributeStory(data, (item, story)=>{
                        if(item.deptId === story.id){
                            item.submitTarget = story.contributeMedia;
                            item.deptName = story.name;
                        }
                    })
                });

                let contributeIds = that.getContributeIds(dataSource);
                contributeIds.length>0 && that.activitiDataConvertContributeInfo(contributeIds, (data)=>{
                    convertContributeStory(data, (item, story)=>{
                        if(item.id === story.id){
                            item.submitTarget = story.submitTarget;
                            item.targetIds = story.targetIds;
                            item.targetType = story.targetType;
                            item.mediaLogo = story.mediaLogo;
                            item.targetInfo = story.targetInfo;
                        }
                    })
                });

                let mediaNewIds = that.getMediaNewIds(dataSource);
                mediaNewIds.length>0 && that.activitiDataConvertReceiveInfoByMediaNews(mediaNewIds, (data)=>{
                    convertContributeStory(data, (item, story)=>{
                        if(item.id === story.mediaNewsId){
                            item.submitTarget = story.contributeMedia;
                            item.targetIds = story.mediaIds;
                            item.targetType = "media";//收稿的不区分投稿方式，只管是否投到了这个媒体下
                            item.submitter = story.submitter;
                            item.submitterName = story.submitterName;
                            // item.id = story.id;
                            item.mediaLogo = story.mediaLogo;
                            item.openEditorStyle = "webStoryEditor";//代表是收稿稿件，要打开收稿的编辑器
                        }
                    })
                });

                let receiveIds = that.getReceiveIds(dataSource);
                receiveIds.length>0 && that.activitiDataConvertReceiveInfo(receiveIds, (data)=>{
                    convertContributeStory(data, (item, story)=>{
                        if(item.id === story.id){
                            item.submitTarget = story.contributeMedia;
                            item.targetIds = story.mediaIds;
                            item.targetType = "media";//收稿的不区分投稿方式，只管是否投到了这个媒体下
                            item.submitter = story.submitter;
                            item.submitterName = story.submitterName;
                            item.mediaLogo = story.mediaLogo;
                            item.openEditorStyle = "receiveEditor";//代表是收稿稿件，要打开收稿的编辑器
                        }
                    })
                });
            },
            errorCallBack: function (e) {
            }

        });
    };

    render() {
        let {tabBar, columns, thisTabKey} = this.state;
        // 根据thisTabKey来决定传tabBar里面的哪些数据
        let {params, data, tabList} = tabBar;

        //获取投稿流程的code
        let activitiConfName = this.sysConfigGetValueByKey("editor.activiti.conf.name.tglc", "activitiTreeRoot-xlc-tglc");
        let tableHeight = window.innerHeight - HEADER_HEIGHT  - 20 - 77 - 15 - 1
        let props = {
            columns: columns,
            params: params,
            onChange: this.onChange,
            data: data,
            tabList: tabList,
            activeKey:thisTabKey,
            tableHeight,
            editorParams: {
                activitiConfName
            },
            changeTabBar: this.changeTabBar
        };
        let statusShow = {
            "已采用":use,
            "已弃用":discard,

        };

        return (
            <div >
                <MyTable {...props}></MyTable>
                <Modal
                    title="投稿至"
                    centered
                    width={400}
                    footer = {null}
                    visible={this.state.submitVisible}
                    onCancel={() => this.setState({submitVisible:false})}
                >
                    <div>
                        <Scrollbars autoHeight autoHeightMax={250} autoHide>
                            {this.state.targetInfo.map((item,index)=>{
                                let status = item.status  && (item.status == "已采用" || item.status == "已弃用")
                                return (<div style={{paddingTop:index==0?0:"20px"}} key={index}>
                                        <div style={{display:"flex",justifyContent: "space-between",alignItem:"center",paddingRight:"20px"}}>
                                            <div title={item.deptName} key={index} style={{fontSize:"16px",fontWeight:"700",width:"240px",overflow: "hidden",textOverflow: "ellipsis",whiteSpace: "nowrap",cursor:"pointer"}}><img src={deptIcon} style={{width:"20px",marginRight:"5px"}}/>{item.deptName}</div>
                                            {/*{item.status==""? <p style={{fontSize:"14px"}}><img src={item.status == "已采用" ? u17 : u22} style={{width:"20px",marginRight:"3px"}}/>{item.status}</p> : ""}*/}
                                            {status? <div ><img src={statusShow[item.status]} style={{width:"20px",marginRight:"3px"}}/>{item.status}</div> : ""}
                                        </div>
                                        <div>
                                            {item.mediaNames&&item.mediaNames.map((Item,Index)=>{
                                                return (
                                                    <div title={Item.name} key={Index} style={{marginLeft:"25px",paddingTop:"10px",width:"240px",overflow:"hidden",textOverflow: "ellipsis",whiteSpace: "nowrap",cursor:"pointer"}}>
                                                        {Item.name}
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                )
                            })}
                        </Scrollbars>
                    </div>
                </Modal>
                <Modal
                    title={"提交媒体"}
                    footer={null}
                    visible={this.state.mediaListModalVisible}
                    onOk={()=>{this.setState({mediaListModalVisible:false})}}
                    onCancel={()=>{this.setState({mediaListModalVisible:false})}}
                    maskClosable={false}
                    className={"rmt-mediaListModalVisible"}
                >
                    <Scrollbars
                        autoHeight={true}
                        autoHeightMax={500}
                        autoHide={true}
                    >
                        <MediaList group={this.state.mediaListData} />
                    </Scrollbars>
                </Modal>
                <style>
                    {
                        `
                        .rmt-mediaListModalVisible .ant-modal-body {
                            padding-top: 18px;
                            padding-bottom: 18px;
                        }
                        `
                    }
                </style>
                <Modal
                    title={"查看发布"}
                    footer={null}
                    visible={this.state.publishMediaListModalVisible}
                    onOk={()=>{this.setState({publishMediaListModalVisible:false})}}
                    onCancel={()=>{this.setState({publishMediaListModalVisible:false})}}
                    maskClosable={false}
                >
                    <Scrollbars
                        autoHeight={true}
                        autoHeightMax={500}
                        autoHide={true}
                    >
                        <MediaList group={this.state.publishMediaListData} showHref={true}/>
                    </Scrollbars>
                </Modal>

                <Modal
                    title={"投稿至"}
                    footer={null}
                    visible={this.state.deptListModalVisible}
                    onOk={()=>{this.setState({deptListModalVisible:false})}}
                    onCancel={()=>{this.setState({deptListModalVisible:false})}}
                    maskClosable={false}
                >
                    <Scrollbars
                        autoHeight={true}
                        autoHeightMax={500}
                        autoHide={true}
                    >
                        {this.props.contributeDept && this.props.contributeDept.join("，")}
                    </Scrollbars>
                </Modal>
                {this.renderModal()}
            </div>
        )
    }

    //子弹窗
    renderModal = () => {
        let {childrenColumn, childrenDataSource} = this.state;
        return (
            <Modal
                title="详情"
                width={1200}
                visible={this.state.showReceiveStoryVisible}
                onCancel={(e) => this.setState({
                    showReceiveStoryVisible: false,
                })}
                footer={null}
                destroyOnClose={true}
                // style={{marginTop: 220}}
            >
                <Scrollbars style={{height: 400}}>
                    <BaseTable columns={childrenColumn} dataSource={childrenDataSource}/>
                </Scrollbars>
            </Modal>
        )
    }

    deleteStory = (storyId) => {
        let that = this;
        this.request({
            url:"/cm-sites-pms/story/delete",
            body: {storyId},
            method: "post",
            callBack: function (res) {
                message.destroy();
                message.success("删除成功");
                that.getDataSource();
            },
            errorCallBack: function (e) {
                console.log(e)
            }

        });
    };

    getReceiveStory = (id, callBack, errorCallBack = ()=>{})=>{
        if(!id) return message.error("稿件id丢失！");
        let url = '/cm-sites-pms/story/getReceiveStory';
        let params = {
            storyId:id
        };
        let that = this;
        this.request({
            url,
            body: params,
            callBack,
            errorCallBack
        });
    };

    showReceiveStory = (id) => {
        this.getReceiveStory(id, (res)=>{
            let childrenDataSource = [];
            if (res) {
                childrenDataSource = res;
            }
            this.setState({recodeId:id,childrenDataSource,showReceiveStoryVisible:true})
        });
    };

    //选项卡
    changeTabBar = (key) => {
        let {tabBar} = this.state;
        this.state.thisTabKey = key;
        // 重置查询参数
        tabBar.params={
            keywords:'',
            page:1,
            size:10
        };
        this.getDataSource();
        this.setState({});
    };

    //搜索
    onChange = (type, e) => {
        let {params} = this.state.tabBar;
        switch (type) {
            case 'onChange':
                params['keywords'] = e.target.value;
                return  this.setState({});
            case 'onSearch':
                params['keywords'] = e;
                params['page'] = 1;
                break;
            case 'page':
                params['page'] = e;
                break;
            case 'size':
                params['size'] = e;
                // 当改变页面容量时，应该直接翻到第一页
                params['page'] = 1;
                break;
        }
        this.getDataSource();
    }
}

NewsContribute.defaultProps = {
    relateWriteVisible: true
};
NewsContribute.propTypes = {};